export { default } from './DealCard';
